export default function setCachedTextAlertsActionCreator(userDuck, personalization) {
  return phone => async dispatch => {
    try {
      const cachedTextAlerts = personalization.getTextAlertsSessionCache();
      // on page load, set user.cachedTextAlert if it is available in session storage
      if (typeof phone === 'undefined' && Object.keys(cachedTextAlerts).length) {
        dispatch({
          type: userDuck.types.CACHED_TEXT_ALERTS,
          payload: cachedTextAlerts.phone
        });
      }
      // user opt in to disable quick save notification, set user.cachedTextAlert and session storage
      if (phone) {
        personalization.setTextAlertsSessionCache({
          phone
        });
        dispatch({
          type: userDuck.types.CACHED_TEXT_ALERTS,
          payload: phone
        });
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.log(error);
    }
  };
}